(function () {
  "use strict";

  if (window.__headerActionsOverflowBootstrap) {
    window.__headerActionsOverflowBootstrap.init(document);
    return;
  }

  var OVERFLOW_BREAKPOINT = 1440;

  function isOverflowMode() {
    return window.matchMedia("(max-width: " + OVERFLOW_BREAKPOINT + "px)").matches;
  }

  function closeMenu(root) {
    var trigger = root.querySelector(".bh-pc__actions-more");
    var menu = root.querySelector(".bh-pc__actions-menu");

    if (!trigger || !menu) return;

    trigger.setAttribute("aria-expanded", "false");
    menu.hidden = true;
  }

  function closeAllMenus(except) {
    document.querySelectorAll(".bh-pc__actions-overflow").forEach(function (root) {
      if (root === except) return;
      closeMenu(root);
    });
  }

  function openMenu(root) {
    var trigger = root.querySelector(".bh-pc__actions-more");
    var menu = root.querySelector(".bh-pc__actions-menu");

    if (!trigger || !menu) return;

    closeAllMenus(root);
    trigger.setAttribute("aria-expanded", "true");
    menu.hidden = false;
  }

  function initOverflow(root) {
    if (root.__headerActionsOverflowController) return;

    var trigger = root.querySelector(".bh-pc__actions-more");

    if (!trigger) return;
    var controller = new AbortController();
    var options = { signal: controller.signal };
    root.dataset.actionsOverflowInit = "true";

    trigger.addEventListener("click", function (event) {
      event.stopPropagation();

      if (!isOverflowMode()) return;

      var expanded = trigger.getAttribute("aria-expanded") === "true";
      if (expanded) {
        closeMenu(root);
      } else {
        openMenu(root);
      }
    }, options);

    root.addEventListener("click", function (event) {
      event.stopPropagation();

      if (event.target.closest(".new-search-container")) {
        closeMenu(root);
      }
    }, options);

    root.__headerActionsOverflowController = {
      destroy: function () {
        closeMenu(root);
        controller.abort();
        delete root.dataset.actionsOverflowInit;
        delete root.__headerActionsOverflowController;
      },
    };
  }

  function findRoots(scope) {
    var roots = [];
    if (scope instanceof Element && scope.matches('.bh-pc__actions-overflow')) roots.push(scope);
    if (scope && scope.querySelectorAll) {
      scope.querySelectorAll('.bh-pc__actions-overflow').forEach(function (root) { roots.push(root); });
    }
    return roots;
  }

  function init(scope) {
    findRoots(scope).forEach(initOverflow);
  }

  function destroy(scope) {
    findRoots(scope).forEach(function (root) { root.__headerActionsOverflowController?.destroy(); });
  }

  function bootstrap() {
    init(document);

    document.addEventListener("click", function () {
      closeAllMenus();
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      closeAllMenus();
    });

    window.addEventListener("resize", function () {
      if (!isOverflowMode()) {
        closeAllMenus();
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootstrap, { once: true });
  } else {
    bootstrap();
  }

  window.__headerActionsOverflowBootstrap = { init: init, destroy: destroy };
  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
  document.addEventListener("shopify:section:unload", function (event) {
    destroy(event.target);
  });
})();
